import type { PropsWithChildren } from 'react';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import clsx from 'clsx';

import styles from './styles/Badge.module.scss';

export const badgeVariants = cva(styles.badge, {
  variants: {
    isRound: {
      true: styles.isRound,
    },
    size: {
      xs: styles['size-xs'],
      s: styles['size-s'],
      m: styles['size-m'],
      l: styles['size-l'],
    },
    variant: {
      primary: styles['primary'],
      secondary: styles['secondary'],
      error: styles['error'],
    },
  },
  defaultVariants: {
    isRound: false,
    size: 'm',
    variant: 'primary',
  },
});

export type BadgeProps = VariantProps<typeof badgeVariants> & PropsWithChildren & { style?: React.CSSProperties };

const Badge = ({
  children,
  className,
  isRound,
  size,
  style,
  variant,
  ...props
}: {
  className?: string;
} & BadgeProps) => (
  <span
    className={clsx(badgeVariants({ isRound, size, variant }), className)}
    data-cxy-name="badge"
    style={style}
    {...props}
  >
    {children}
  </span>
);

export { Badge };
